
<template>
    <div class="homePage" style="width: 100%; height: 100%">
        <Header @settheme="getThemeBg" />
        <LogReg  v-show="login"/>
        <!-- 首页头部 -->
        <div id="nav" v-if="userInfo.orgId != '3883'" :style="{backgroundImage:'url('+currentBg+')'}">
            <div id="UIFrame_823134" style="display: block;">
                <div class="wrap" >
                    <div class="nav_box">
                        <div class="nav_search" style="display:flex;height:80px;justify-content: flex-start;align-items: center"> 
                            <div class="logo_left">
                                <img v-if="userInfo.orgId == '3431'" :src="logoImg" style="width: 270px;height: 120px;vertical-align: -12px;" /> 
                                <h2 v-else style="font-size:26px;letter-spacing:2px;font-weight:normal;">
                                    <img v-if="logoImg" :src="logoImg" style="width:45px;height: 45px;vertical-align: -12px;" />
                                    {{ userInfo.orgName }}
                                </h2>
                            </div>                               
                            <div class="search_right">
                                <div class="search">
                                    <el-select v-model="typeVal" @change="selectChange">
                                        <el-option label="普通搜索" value="0"></el-option>
                                        <el-option label="词典搜索" value="1"></el-option>
                                        <el-option label="问答检索" value="2"></el-option>
                                        <el-option label="二次检索" value="3"></el-option>
                                        <el-option label="目次检索" value="4"></el-option>
                                    </el-select>
                                    <div class="searchbox1" style="display: flex;">
                                        <el-input class="search_input" :placeholder="placeholder" id="keyword" @keyup.enter.native="keyword" v-model="search"></el-input>                                                                   
                                        <a href="javascript:;" class="search_icon" id="search" @click="keyword"></a>
                                        <!-- 简繁体通检 开关区域 -->
                                        <div class="ft-toggle" style="float:right;margin-top: 5px;">
                                            <el-checkbox v-model="ftCheck"></el-checkbox>
                                            <span style="font-size:12px;color: #666;">简繁体通检</span>
                                        </div>
                                    </div>
                                    <div class="serach_tip" v-show="isNullWord">
                                        <p>请输入关键字进行搜索！</p>
                                    </div>
                                </div>
                                <div class="headerNavRight">
                                    <el-popover placement="top-start">
                                        <el-button @click="historyArr" style="background:none;border:0" class="icp_txt" slot="reference">浏览历史</el-button>
                                        <div class="pull_list" style="overflow:hidden;" v-for="(item, index) in historyBook" :key="index">
                                            <p style="height: 40px;border-bottom: 1px dashed #ccc;padding: 10px;" @click="goBookDetails(item)">
                                                <a class="hand" style="font-size: 16px;text-decoration: none;">
                                                    <b>{{ item.bookName }}</b>
                                                </a>
                                                <br/>
                                                <em style="color: #999;">{{ item.author }}</em>
                                            </p>
                                        </div>
                                        <!-- <div style="width:100%;margin-top: 20px;text-align: center;">
                                            <el-button style="border-radius:20px;color:#fff;background:#3daca5;margin:0 30px;width:150px" @click="history">查看书架</el-button>
                                        </div> -->
                                    </el-popover>
                                </div> 
                            </div>
                        </div>
                    </div>
                    <div class="nav" id="jsnavbox" style="display:flex;height:60px;justify-content: space-between;align-items: center; margin: 0">
                        <ul>
                            <li class="current">
                                <router-link :to="{path:'/home/homePage'}" class="tab_color">
                                    <i class="home"></i>
                                    首页
                                </router-link>
                            </li>
                            <li class="current">
                                    <router-link :to="{name:'libraryResources'}"  class="tab_color">
                                        <i class="classify"></i>
                                        本馆资源
                                    </router-link> 
                                    <!-- <router-link :to="{name:'libraryBookByClassify'}"  class="tab_color">
                                        <i class="classify"></i>
                                        本馆资源
                                    </router-link>  -->
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[14].type == 15 && config[14].enableStatus == 1) : false">
                                    <router-link :to="{name:'themeBook'}"  class="tab_color">
                                        <i class="theme"></i>
                                        专题书单
                                    </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[10].type == 11 && config[10].enableStatus == 1) : false">
                                    <router-link :to="{name:'HighSearch'}"  class="tab_color">
                                        <i class="ques"> </i>
                                        高级检索
                                    </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[27].type == 28 && config[27].enableStatus == 1) : false">
                                <router-link :to="{name:'AIReadlist'}"  class="tab_color">
                                    <i class="airead"> </i>
                                    AI阅读专区
                                </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[11].type == 12 && config[11].enableStatus == 1) : false">
                                    <router-link :to="{name:'youSheng'}"  class="tab_color">
                                        <i class="yousheng"> </i>
                                        有声读物
                                    </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[12].type == 13 && config[12].enableStatus == 1) : false">
                                <router-link :to="{name:'journal'}"  class="tab_color">
                                    <i class="joural"></i>
                                    期刊
                                </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[13].type == 14 && config[13].enableStatus == 1) : false">
                                <router-link :to="{name:'onlineCourse'}"  class="tab_color">
                                    <i class="course"> </i>
                                    在线课程
                                </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[6].type == 7 && config[6].enableStatus == 1) : false">
                                <router-link :to="{name:'tryReadeBook'}"  class="tab_color">
                                    <i class="grad"></i>
                                    试读
                                </router-link>
                                <!-- <router-link :to="{name:'searchBookByClassify'}"  class="tab_color">
                                    <i class="grad"> </i>
                                    试读
                                </router-link> -->
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[24].type == 25 && config[24].enableStatus == 1) : false">
                                <router-link :to="{name:'departmentClassify'}"  class="tab_color">
                                    <i class="depart"> </i>
                                    院系分类
                                </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[25].type == 26 && config[25].enableStatus == 1) : false">
                                <router-link :to="{name:'publicTheme'}"  class="tab_color">
                                    <i class="pubtheme"> </i>
                                    出版社专题
                                </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[28].type == 29 && config[28].enableStatus == 1) : false">
                                <router-link :to="{name:'catalogInfo'}"  class="tab_color">
                                    <i class="pubtheme"> </i>
                                    新书征订目录
                                </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[32].type == 33 && config[32].enableStatus == 1) : false">
                                <router-link :to="{name:'scjfZone'}"  class="tab_color">
                                    <i class="depart"> </i>
                                    圣才教辅题库专区
                                </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[34].type == 35 && config[34].enableStatus == 1) : false">
                                <router-link :to="{name:'kxwkZone'}" class="tab_color">
                                    <i class="pubtheme"> </i>
                                    <!-- 科学文库专区 -->
                                     科学社纸电同采专区
                                </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[33].type == 34 && config[33].enableStatus == 1) : false">
                                <router-link :to="{name:'ebookBuy'}"  class="tab_color">
                                    <i class="grad"> </i>
                                    纸电采选
                                </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[36].type == 37 && config[36].enableStatus == 1) : false">
                                <router-link :to="{name:'buyList'}"  class="tab_color">
                                    <i class="theme"> </i>
                                    采选书单
                                </router-link> 
                            </li>
                            <li class="current" v-if="config.length > 0 ? (config[35].type == 36 && config[35].enableStatus == 1) : false">
                                <router-link :to="{name:'subBook'}"  class="tab_color">
                                    <i class="course"> </i>
                                    图书征订
                                </router-link> 
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <router-view :key="$route.fullPath"></router-view>
        <!-- <HomePage  /> -->
        <Footer v-if="userInfo.orgId != '3883'" />
    </div>
</template>

<script>
import Footer from "../components/Footer.vue";
import Header from "../components/Header.vue";
import Login from "../views/Login/Login";
import HomePage from "../views/HomePage.vue"
import LogReg from "../views/LogReg.vue"
import { getUserInfo, setItem } from "@/common/utils/localStorage.js";
import { updateByid } from "@/api/visitlog";//浏览历史
import { ids, orderly } from "@/api/ebook";//处理数据
import { bgImgList, setConfig } from "@/api/user.js";
export default {
    data() {
        return {
            typeVal: '0', 
            userInfo: getUserInfo(),
            logoImg: getUserInfo().orgLogo || '',
            login: false,
            search: "",
            historyInfo: false,
            hisBook: [],
            ebookId: [],//浏览历史id
            ebookIdArr: "",//处理浏览历史id
            historyBook: [],//浏览历史的书
            show: true,
            config:[],
            isNullWord: false,
            placeholder:'书名、作者、出版社、ISBN、分类、摘要、出版年月',
            type: 0,
            currentBg:'',
            ftCheck: true,
        };
    },
    components: {
        Header,
        Footer,
        HomePage,
        LogReg
    },
    created() {
        let vm = this;
        if(this.$route.query.type) vm.typeVal = vm.$route.query.type;
        if(this.$route.query.word) vm.search = vm.$route.query.word;
        if(this.$route.query.wordtwo) vm.search = vm.$route.query.wordtwo;
        if(Object.keys(vm.userInfo).length === 0) {
            
        }else{
            vm.getThemeBg();
            vm.getSetConfig();
            // vm.config = JSON.parse(getItem('config'));
        }
    },
    mounted() { 
        let userInfo = getUserInfo();
        this.$bus.$on('login', (data)=>{
            if(data == "true") {
                this.login = true
            }
        });
        this.$bus.$on('success', (data)=>{
            if(data == "false") {
                this.login = false
            }
        })
        // if(userInfo.demoSignal == 1) {
        //     this.show = false
        // }
    },
    methods: {
        getThemeBg(){
            let vm = this;
            bgImgList({
                orgId: getUserInfo().orgId,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            }).then(res => {
                if(res.status){
                    let bg = res.data.list.filter(item=>item.isSetBackground==1);
                    vm.currentBg = bg[0].backgroundImage;
                }
            }).catch(err => {

            });
        },
        selectChange(val){
            let vm = this;
            if(val == '2'){//问题检索
                vm.placeholder = '请提出您要查询的问题...';
            }else{
                vm.placeholder = '书名、作者、出版社、ISBN';
            }
        },
        //获取权限显示
        getSetConfig(){
            let t = this,
                obj = {
                    // orgId: getUserInfo().orgId,
                    visitType: 2,
                    visitUrl: location.href,
                    visitFunc: "",
                };
            setConfig(obj).then(res => {
                if(res.status){
                    // t.config = res.data;
                    let configData = [],
                        list = {};
                    for(var i = 1;i<=40;i++){
                        let list = {type:i, orgId:getUserInfo().orgId, dataStatus:1, enableStatus: 2}; //默认不显示
                        res.data.map((item, index) =>{
                            if(item.type == i){
                                // list.pkid = item.pkid;
                                list.enableStatus = item.enableStatus;
                                return true;
                            }
                        });
                        configData.push(list);
                    }
                    t.config = configData;
                    setItem('config', JSON.stringify(configData));
                }
            }).catch(err => {

            });
        },
        history() {
            this.$router.push({name:"shelfTypeList"})
        },
        // 显示历史
        historyArr() {
            let vm = this;
            vm.historyInfo = true;
            vm.updateByid();
        },
        // 隐藏历史
        hideHistoryArr() {
            let vm = this;
            vm.historyInfo = false;
            vm.ebookId = [];
        },
        // 请求浏览历史
        updateByid() {
            let userInfo = getUserInfo();
            let vm = this;
            vm.ebookId = []
            vm.ebookIdArr = []
            var obj = {
                pageNum: 1,
                pageSize: 3,
                "creatorId": userInfo.pkid,
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            updateByid(obj).then((res) => {
                vm.hisBook = res.data.list;
                vm.hisBook.forEach(item => {
                    vm.ebookId.push(item.ebookId);
                });
                vm.ebookIdArr = vm.ebookId.join(",");
                vm.ids(vm.ebookIdArr);
            });
        },
        //处理浏览历史id
        ids(ebookIdArr) {
            let userInfo = getUserInfo();
            let vm = this,
                obj = {
                    pkids: ebookIdArr,
                    visitType: 2,
                    visitUrl: location.href,
                    visitFunc: "",
                    pageNum: 1,
                    pageSize: 3,
                };
            orderly(obj).then((res) => {
                vm.historyBook = res.data.list
            });
        },
        // 进入查询页
        keyword() {
            if(this.search != '') {
                this.isNullWord = false;
                if(this.typeVal == 3){
                    this.$router.push({path:"/Home/searchResultsBook",query:{word: this.$route.query.word, wordtwo: this.search, type: this.typeVal}});
                }else{
                    this.$router.push({path:"/Home/searchResultsBook",query:{word: this.search, type: this.typeVal}});
                }
            } else{
                this.isNullWord = true;
                setTimeout(() => {
                    this.isNullWord = false;
                }, 2000);
            }
        },
        // 跳转详情页
        goBookDetails(item) {
            // if (item.source == 1) {
                let routeData = this.$router.resolve({ path: "/home/bookDetails", query: { pkid: item.pkid, source:item.source } })
                window.open(routeData.href, '_blank');
            // } else {
            //     window.open(item.readUrl)
            // }
        },
    },
};
</script>

<style lang="scss" scoped>
.homePage {
    // display: flex;
    // flex-direction: column;
    // height: 100%;
    // width: 100%;
    .serach_tip{
        box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.15);
        background-color: #2eb497;
        position: absolute;
        top: 55px;
        left:20px;
        padding: 0 10px;/* 简写形式，同时设置多个属性 */
        transition: width 0.5s ease-in-out 0.1s, height 0.3s ease-out;
        // border-radius: 8px;
        &::before{
            display: inline-block;
            content: '';
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 0px solid transparent;
            border-bottom: 10px solid #2eb497;
            position: absolute;
            top: -10px;
            left: 10px;
        }
        >p{
            color: #fff;
        }
    }
}
::v-deep.el-popover {
    width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue